import { Control } from "react-hook-form";
import { Box } from "@mui/material";
import FormTextField from "../../components/form/FormTextField";
import { BranchAuthenticationType, ofBranch } from "../../types/branch";
import React from "react";
import FormSelectField from "../../components/form/FormSelectField";
import { useTranslation } from "react-i18next";

export function BranchForm(props: { control: Control; createMode: boolean }) {
  const { t } = useTranslation();
  return (
    <Box
      component="form"
      sx={{ display: "flex", flexDirection: "column" }}
      autoComplete="off"
    >
      <FormTextField
        name={ofBranch("name")}
        control={props.control}
        label={"Name"}
        required
      />
      <FormTextField
        name={ofBranch("abbreviation")}
        control={props.control}
        label={"Abbreviation"}
        helperText={"Identificator of this branch. Cannot be changed later."}
        disabled={!props.createMode}
        required
      />
      <FormTextField
        name={ofBranch("contact")}
        control={props.control}
        label={"Contact email"}
        additionalRules={{
          pattern: {
            value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
            message: "Invalid Email",
          },
        }}
      />
      <FormSelectField
        name={ofBranch("authenticationType")}
        control={props.control}
        label={"Authentication Type"}
        list={Object.values(BranchAuthenticationType)}
        getListLabel={(e) => t(`common.BranchAuthenticationType.${e}`)}
      />
    </Box>
  );
}
